module.exports = __webpack_public_path__ + "4bde4b9f11b9991f527769ee92735c25.svg";